import { Box, Typography } from "@mui/material";
import { formatInteger } from "../formatters";
import {
  BRAND_STAGES,
  StageCounts,
  formatOptionalPercent,
  formatOptionalSignedPercent,
  retainedPercent,
  vsPreviousPercent,
} from "./brandStagesApiMapping";

// Styles for the MUI Tooltip that hosts BrandStagesTooltipContent - a white
// card instead of MUI's default dark tooltip (per the mockup).
export const BRAND_STAGES_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      backgroundColor: "#fff",
      color: "#212121",
      border: "1px solid #e6e6e6",
      boxShadow: "0 8px 28px rgba(0,0,0,.14)",
      borderRadius: "10px",
      p: "12px 14px",
      minWidth: 230,
      maxWidth: "none",
    },
  },
  popper: { sx: { pointerEvents: "none" } },
};

interface BrandStagesTooltipContentProps {
  stageIndex: number;
  counts: StageCounts;
  scopeLabel: string;
  rangeLabel: string;
}

// Hover card shared by the All-brands funnel rows and the matrix cells
// (spec Section 3.3/3.4): users, retained from Paid, vs previous step.
export default function BrandStagesTooltipContent({
  stageIndex,
  counts,
  scopeLabel,
  rangeLabel,
}: BrandStagesTooltipContentProps) {
  const change = vsPreviousPercent(counts, stageIndex);
  const changeColor = change === null ? "#9e9e9e" : change < 0 ? "#C62828" : "#2E7D32";

  return (
    <Box>
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a" }}>{BRAND_STAGES[stageIndex].name}</Typography>
      <Typography sx={{ fontSize: 11.5, color: "#9e9e9e", mb: 1 }}>
        {scopeLabel} · reported {rangeLabel}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "auto auto",
          columnGap: 2,
          rowGap: 0.5,
          fontSize: 12.5,
        }}
      >
        <Box component="span" sx={{ color: "#757575" }}>
          Users
        </Box>
        <Box component="span" sx={{ fontWeight: 700, color: "#212121", textAlign: "right" }}>
          {formatInteger(counts[stageIndex])}
        </Box>
        <Box component="span" sx={{ color: "#757575" }}>
          Retained from Paid
        </Box>
        <Box component="span" sx={{ fontWeight: 700, color: "#212121", textAlign: "right" }}>
          {formatOptionalPercent(retainedPercent(counts, stageIndex))}
        </Box>
        <Box component="span" sx={{ color: "#757575" }}>
          vs previous step
        </Box>
        <Box component="span" sx={{ fontWeight: 700, color: changeColor, textAlign: "right" }}>
          {formatOptionalSignedPercent(change)}
        </Box>
      </Box>
      <Typography sx={{ fontSize: 11.5, color: "#8E24AA", mt: 1, fontWeight: 500 }}>
        Click to open these leads →
      </Typography>
    </Box>
  );
}
